module.exports = __webpack_public_path__ + "img/home.dd15d730.svg";